import { Component } from '@angular/core';
import { FlowpilotChatsContainerComponent } from '@core/components/sidebar/components/flowpilot/window/content/components/chats/flowpilot-chats-container.component';

@Component({
  selector: 'app-flowpilot-chat-pop-up-layout',
  imports: [FlowpilotChatsContainerComponent],
  template: `
    <app-flowpilot-chats-container>
      <div class="flex flex-col gap-y-2.5">
        <div class="flex flex-col gap-y-1">
          <ng-content select="[actions]" />
        </div>
      </div>

      <ng-content select="[chats]" />
    </app-flowpilot-chats-container>
  `,
})
export class FlowpilotChatPopUpLayoutComponent {}
